/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Activity_TitleInputs */

const id_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitas`)
};

const ms_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktiviti`)
};

const da_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitet`)
};

const de_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivität`)
};

const en_us2_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity`)
};

const es_es2_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad`)
};

const es_mx2_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actividad`)
};

const fil_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktibidad`)
};

const fr_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activité`)
};

const it_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attività`)
};

const hu_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tevékenység`)
};

const nl_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activiteit`)
};

const no_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitet`)
};

const pl_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktywność`)
};

const pt_br2_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade`)
};

const pt_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atividade`)
};

const ro_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activitate`)
};

const fi_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toiminta`)
};

const sv_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitet`)
};

const vi_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoạt động`)
};

const tr_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivite`)
};

const cs_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivita`)
};

const bg_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активност`)
};

const ru_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активность`)
};

const uk_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Активність`)
};

const ar_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النشاط`)
};

const hi_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गतिविधि`)
};

const th_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กิจกรรม`)
};

const ja_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティビティ`)
};

const zh_cn2_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`动态`)
};

const zh_hant1_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動態`)
};

const ko_profile_activity_title = /** @type {(inputs: Profile_Activity_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`활동`)
};

/**
* | output |
* | --- |
* | "Activity" |
*
* @param {Profile_Activity_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_activity_title = /** @type {((inputs?: Profile_Activity_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Activity_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_activity_title(inputs)
	if (locale === "ms") return ms_profile_activity_title(inputs)
	if (locale === "da") return da_profile_activity_title(inputs)
	if (locale === "de") return de_profile_activity_title(inputs)
	if (locale === "en-US") return en_us2_profile_activity_title(inputs)
	if (locale === "es-ES") return es_es2_profile_activity_title(inputs)
	if (locale === "es-MX") return es_mx2_profile_activity_title(inputs)
	if (locale === "fil") return fil_profile_activity_title(inputs)
	if (locale === "fr") return fr_profile_activity_title(inputs)
	if (locale === "it") return it_profile_activity_title(inputs)
	if (locale === "hu") return hu_profile_activity_title(inputs)
	if (locale === "nl") return nl_profile_activity_title(inputs)
	if (locale === "no") return no_profile_activity_title(inputs)
	if (locale === "pl") return pl_profile_activity_title(inputs)
	if (locale === "pt-BR") return pt_br2_profile_activity_title(inputs)
	if (locale === "pt") return pt_profile_activity_title(inputs)
	if (locale === "ro") return ro_profile_activity_title(inputs)
	if (locale === "fi") return fi_profile_activity_title(inputs)
	if (locale === "sv") return sv_profile_activity_title(inputs)
	if (locale === "vi") return vi_profile_activity_title(inputs)
	if (locale === "tr") return tr_profile_activity_title(inputs)
	if (locale === "cs") return cs_profile_activity_title(inputs)
	if (locale === "bg") return bg_profile_activity_title(inputs)
	if (locale === "ru") return ru_profile_activity_title(inputs)
	if (locale === "uk") return uk_profile_activity_title(inputs)
	if (locale === "ar") return ar_profile_activity_title(inputs)
	if (locale === "hi") return hi_profile_activity_title(inputs)
	if (locale === "th") return th_profile_activity_title(inputs)
	if (locale === "ja") return ja_profile_activity_title(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_activity_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_activity_title(inputs)
	return ko_profile_activity_title(inputs)
});
export { profile_activity_title as "profile.activity.title" }